import { FC, useState, ChangeEvent, useRef, useEffect, KeyboardEvent } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { ReactComponent as SendIcon } from 'src/assets/send.svg';
interface SenderProps {
  sendMessage: (message: Message) => void;
  onTextInputChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const Sender: FC<SenderProps> = ({ sendMessage, onTextInputChange }: SenderProps) => {
    const classes = useStyles();
    const [newMessage, setNewMessage] = useState("")

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => { inputRef.current?.focus(); }, []);

    const handlerOnChange = (event: ChangeEvent<HTMLInputElement>) => {
      setNewMessage(event.target.value)
      onTextInputChange && onTextInputChange(event)
    }

    const handlerOnKeyPress = (event: KeyboardEvent) => {
      const spaceBarKeyCode = "Enter"
      if(event.key === spaceBarKeyCode && !event.shiftKey) {
        event.preventDefault()
        handlerSendMessage();
      }
    }

    const handlerSendMessage = () => {
      if(!newMessage || newMessage === '') {
        return
      }

      const message: Message = {
        senderType: 'myself',
        text: newMessage,
        timestamp: new Date().getTime()
      }
      sendMessage(message);
      setNewMessage("")
    }

    return (
      <div className={classes.root}>
        <label
          htmlFor="simulator-input"
          className={classes.label}
          onKeyPress={handlerOnKeyPress}>
          <input
            id="simulator-input"
            autoComplete="off"
            className={classes.input}
            type="text"
            spellCheck
            value={newMessage}
            onChange={handlerOnChange}
            ref={inputRef} />
          <button type="submit" className={classes.sendButton} onClick={handlerSendMessage}>
            <SendIcon />
          </button>
        </label>
      </div>
    );
};

Sender.defaultProps = { };

export default Sender;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "50px",
    padding: "10px 12px 10px 8px",
    borderRadius: "8px",
    backgroundColor: "#f0f0f0",
    position: "relative",
  },
  label: {
    position: "relative",
    height: "50px",
    display: "grid",
    gridTemplateColumns: "8fr 1fr",
    alignItems: "center",
    padding: "0 16px 0 15px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  input: {
    outline: "none",
    border: "none",
    caretColor: "#0091ff",
    fontFamily: "Poppins"
  },
  sendButton: {
    background: "none",
    justifySelf: "flex-end",
    outline: "none",
    border: "none",
    cursor: "pointer",
  }
}));
